<template>
    <v-container fluid class="text-xs-center"> 
        <v-layout row wrap>
            <v-form>
                <v-container>
                    <div class="vrow">
                        <h4>Dati dell'animale</h4>
                        <v-text-field
                            v-model="pet.name"
                            :counter="40"
                            label="Nome"
                            required
                        ></v-text-field>
                        <v-text-field
                            v-model="pet.species"
                            :counter="40"
                            label="Specie"
                            required
                        ></v-text-field>
                        <v-text-field
                            v-model="pet.breed"
                            :counter="40"
                            label="Razza"
                            required
                        ></v-text-field>
                        <v-text-field
                            v-model="pet.size"
                            :counter="15"
                            label="Dimensioni"
                            required
                        ></v-text-field>
                        <v-text-field
                            v-model="pet.weight"
                            :counter="40"
                            label="Peso"
                            required
                        ></v-text-field>
                        <v-text-field
                            v-model="pet.microchip"
                            :counter="15"
                            label="Microchip"
                            required
                        ></v-text-field>
                        <v-text-field
                            v-model="pet.birthday"
                            type="date"
                            label="Compleanno"
                            required
                        ></v-text-field>
                        <v-text-field
                            v-model="pet.compatibility"
                            :counter="40"
                            label="Compatibilità"
                            required
                        ></v-text-field>
                        <v-text-field
                            v-model="pet.notes"
                            :counter="300"
                            label="Note"
                            required
                        ></v-text-field>
                    </div>
                    <div class="vrow">
                        <h4>Dati sanitari</h4>
                        <v-text-field
                            v-model="pet.vaccinationDate"
                            type="date"
                            label="Data vaccinazione"
                            required
                        ></v-text-field>
                        <v-text-field
                            v-model="pet.antiparasiticDate"
                            type="date"
                            label="Data antiparassitario"
                            required
                        ></v-text-field>
                        <v-text-field
                            v-model="pet.pathologies"
                            :counter="300"
                            label="Patologie"
                            required
                        ></v-text-field>
                    </div>
                </v-container>
            </v-form>
        </v-layout>
        <v-btn
            dark
            absolute
            bottom
            right
            fab
            color="green"
            style="bottom:20px;"
            @click.native="createCustomer()"
            > <v-icon style="font-size:40px;padding-top:5px;">check</v-icon>
        </v-btn>
    </v-container>
</template>

<script>
const axios = require('axios').default;
export default {
    name: 'PetAdd',
    data: function(){
        return{
            pet:{
                name:null,
                customerId:null,
                breed:null,
                species:null,
                size:null,
                weight:null,
                birthday:null,
                microchip:null,
                vaccinationDate:null,
                antiparasiticDate:null,
                compatibility:null,
                pathologies:null,
                notes:null,
                isBreeded:0
            }
        };
    },
    mounted: function(){
        let vm = this;
        vm.pet.customerId = vm.$route.params.customerId;
    },
    methods:{
        createCustomer(){
            let vm = this;
            axios({
                method: "POST",
                url: vm.$API_BASE_URL + "createPet.php",
                data: vm.pet,
                headers: {
                    'Authentication-Token': window.localStorage.getItem("sogno_at")
                }
            })
            .then(function (response) {
                if (response.status == 200) {
                    vm.$router.push({name: 'customer', params:{customerId:vm.$route.params.customerId}});
                } 
                else{
                    alert("Si è verificato un errore durante il caricamento");
                }
            })
            .catch(function (error) {
                if(error.response.status==403||error.response.status==401){
                    vm.$router.push({name: 'login'});
                }
                else{
                    alert("Si è verificato un errore durante il caricamento");
                    console.error(error)
                }
            });
        }
    }
}
</script>

<style>
.vrow{
    display: inline-block;
    width:48%;
    padding-right:2%;
    vertical-align: top;
}
@media all and (max-width:500px){
    .vrow{
        width:100%;
        padding-right:0;
    }
}
.v-form{
    width:100%;
}
h4{
    font-size: 20px;
}
</style>
